module.exports = __webpack_public_path__ + "static/week_columns_with_task_list-d8f97b12bf5fed9554e0ac4eadadcc7f.png";